// @flow
import type { Dispatch as ReduxDispatch } from 'redux';
import type { Request } from '../types/request';

import recordRequestService from '../services/record-request-service';

type Action = {
  type: string,
  [string]: any
}
type ActionType = Action;

type RequestsState = {
  items: Request[],
  item: ?Request,
  working: Request[],
  loading: boolean,
  error: ?string,
  signUrl: string
}

type PromiseAction = Promise<ActionType>;
type GetState = () => { institutions: RequestsState };
type ThunkAction = (dispatch: ReduxDispatch, getState: GetState) => any;
type Dispatch = (action: Action | ThunkAction | PromiseAction | Array<Action>) => any;

// GET async actions
function getRequest(): Action {
  return {
    type: 'GET_REQUESTS_REQUEST'
  };
}

function getError(error: string) {
  return {
    type: 'GET_REQUESTS_ERROR',
    error
  };
}

function getSuccess(requests: Request[]): Action {
  return {
    type: 'GET_REQUESTS_SUCCESS',
    requests
  };
}


export default function fetchRequests(): ThunkAction {
  return (dispatch: Dispatch) => {
    dispatch(getRequest());
    return recordRequestService
      .all()
      .then((requests: Request[]) => (
        dispatch(getSuccess(requests))))
      .catch((error) => dispatch(getError(error)));
  };
}


// WEBPACK FOOTER //
// ./src/actions/requests.js